import {
  editMenuItems,
  editMenuLabels,
  documentType,
  documentEditNotificationMessages,
  primaryDocType,
  renameModalFields,
} from "./constants";
import styles from "./Documents.module.scss";
import { appRoutes } from "../../constants/appRoutes";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import DocumentServices from "../../services/documents.services";
import { Input, message, Modal } from "antd";
import { useState } from "react";
import { MakeDocumentPrimaryType } from "../../Types/documentsTypes";
import ConditionalRender from "../../reusable-components/ConditionalRender";

const EditMenuItem = ({ id, isPrimary, docType, name, refetchDetails }) => {
  const navigate = useHistory();
  const { SaveDocumentAttributes, MakeDocumentPrimary } = DocumentServices();
  const { mutateAsync: saveDocumentAttributes, isPending: isSavePending } =
    SaveDocumentAttributes();
  const { mutateAsync: makeDocumentPrimary, isPending: isMakePrimaryPending } =
    MakeDocumentPrimary();
  const [isRenameModalOpen, setRenameModalOpen] = useState(false);
  const [newDocumentName, setNewDocumentName] = useState(null);
  const editHandler = () => {
    if (isPrimary || !id) {
      return;
    } else {
      if (docType === documentType.quote) {
        navigate.push(`${appRoutes.EDIT_QUOTE_TEMPLATE}${id}`);
      }
      if (docType === documentType.estimate) {
        navigate.push(`${appRoutes.EDIT_ESTIMATE_TEMPLATE}${id}`);
      }
    }
  };
  const renameHandler = () => {
    setRenameModalOpen(true);
  };

  const onRenameSubmit = async () => {
    await saveDocumentAttributes(
      {
        id: id,
        templateName: newDocumentName,
      },
      {
        onSuccess: () => {
          message.success(documentEditNotificationMessages.renameSuccess);
          setRenameModalOpen(false);
          refetchDetails();
        },
        onError: () => {
          message.error(documentEditNotificationMessages.renameFailure);
          setRenameModalOpen(false);
        },
      }
    );
  };

  const makePrimaryHandler = async () => {
    const payload: MakeDocumentPrimaryType = {
      id: id,
      docType:
        docType === documentType.quote
          ? primaryDocType.quote
          : primaryDocType.estimate,
    };
    await makeDocumentPrimary(payload, {
      onSuccess: () => {
        message.success(documentEditNotificationMessages.makePrimarySuccess);
        refetchDetails();
      },
      onError: () => {
        message.error(documentEditNotificationMessages.makePrimaryFailure);
      },
    });
  };

  const onClickHandler = (action?: string) => {
    switch (action) {
      case editMenuLabels.edit:
        return editHandler();
      case editMenuLabels.rename:
        return renameHandler();
      case editMenuLabels.primary:
        return makePrimaryHandler();
    }
  };
  return (
    <>
      <Modal
        zIndex={1000000}
        width={550}
        visible={isRenameModalOpen}
        onCancel={() => setRenameModalOpen(false)}
        title={renameModalFields.title}
        okText={renameModalFields.okButtonLabel}
        onOk={onRenameSubmit}
        destroyOnClose={true}
        okButtonProps={{
          disabled: !newDocumentName || !name,
        }}
      >
        <div className={styles.RenameTitle}>
          <p>{renameModalFields.content}</p>
        </div>
        <Input
          onChange={(e) => setNewDocumentName(e.target.value)}
          defaultValue={name}
          maxLength={renameModalFields.maxLimit}
        ></Input>
        <ConditionalRender
          visible={newDocumentName?.length === renameModalFields.maxLimit}
        >
          <div className={styles.renameError}>{renameModalFields.error}</div>
        </ConditionalRender>
      </Modal>
      <div className={styles.editMenuContainer}>
        {editMenuItems?.map?.((item) => {
          if (
            (isPrimary && item?.name === editMenuLabels.edit) ||
            (isPrimary && item?.name === editMenuLabels.primary)
          ) {
            return;
          }
          return (
            <div
              key={item?.name}
              className={styles.menuItem}
              onClick={() => onClickHandler(item?.name)}
            >
              <img src={item?.icon} alt={item?.name} />
              <div>{item?.name}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default EditMenuItem;
